export class EdpReponseDefaultResult {
    Skip = 0;
    Top = 0;
    TotalCount = 0;
    Collection: any[] | any = [];
    rowCount = 0;
    result = false;
    lastInsertId = 0;
    errorCode = 0;
    ErrorMessage = "";
}

export class EdpResponseBody {
    Success: boolean;
    Result: EdpReponseDefaultResult;

    constructor() {
        this.Result = new EdpReponseDefaultResult();
    }
}

export class EdpResponse {
    Header: {[index: string]: any};
    Body: EdpResponseBody;

    constructor() {
        this.Body = new EdpResponseBody();
    }
}
